module.exports = __webpack_public_path__ + "static/media/Vytas-Solderholm.07864257.jpg";